import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../config";

const baseUrl = BASE_URL + "form-template";

// Create Form Template
export const createFormTemplate = createAsyncThunk(
  "formTemplate/create",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}/create`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error creating form template"
      );
    }
  }
);

// Update Form Template
export const updateFormTemplate = createAsyncThunk(
  "formTemplate/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${baseUrl}/update/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error updating form template"
      );
    }
  }
);

// Get Form Template by ID
export const getFormTemplateById = createAsyncThunk(
  "formTemplate/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseUrl}/get-by-id/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching form template"
      );
    }
  }
);

// Get All Form Templates
export const getAllFormTemplates = createAsyncThunk(
  "formTemplate/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseUrl}/get-all`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching form templates"
      );
    }
  }
);

// Get All Form Templates For Part
export const getAllFormTemplatesForPart = createAsyncThunk(
  "formTemplate/getAllForPart",
  async ({partId}, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseUrl}/get-all?part_ref=${partId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching form templates"
      );
    }
  }
);

// Delete Form Template
export const deleteFormTemplate = createAsyncThunk(
  "formTemplate/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${baseUrl}/delete/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error deleting form template"
      );
    }
  }
);

const formTemplateSlice = createSlice({
  name: "formTemplate",
  initialState: {
    formTemplates: [],
    formTemplate: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createFormTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(createFormTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.formTemplates.push(action.payload);
      })
      .addCase(createFormTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error || "An error occured";
      })
      .addCase(updateFormTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateFormTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.formTemplates = state.formTemplates.map((template) =>
          template.id === action.payload.id ? action.payload : template
        );
      })
      .addCase(updateFormTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error || "An error occured";
      })
      .addCase(getFormTemplateById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFormTemplateById.fulfilled, (state, action) => {
        state.loading = false;
        state.formTemplate = action.payload;
      })
      .addCase(getFormTemplateById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error || "An error occured";
      })
      .addCase(getAllFormTemplates.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllFormTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.formTemplates = action.payload.results;
      })
      .addCase(getAllFormTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error || "An error occured";
      })
      .addCase(deleteFormTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFormTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.formTemplates = state.formTemplates.filter(
          (template) => template.id !== action.payload
        );
      })
      .addCase(deleteFormTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error || "An error occured";
      });
  },
});

export default formTemplateSlice.reducer;
